<template>
  <div class="etr componentview">
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="8">
            <b-button
              v-print="'#paper'"
              squared
              size="sm"
              class="mr-4 inline"
              title="Print"
              :disabled="busy"
            >
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
            <div class="inline-block">
              <i class="fa fa-car fa-2x mr-1 text-primary"></i>

              <span class="h4 ml-1 text-primary"
                >Confirmation No: {{ item.confirmationno }}</span
              >
            </div>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="busy" rounded="sm">
          <div id="paper" class="mb-3 p-4 background-white text-secondary">
            <div class="border-black p-4">
              <b-row>
                <b-col cols="2">
                  <!-- <img
                    class="logo mt-4 ml-4 h-50px"
                    src="/img/brand/ABTA.jpg"
                    alt="ABTA"
                /> -->
                </b-col>
                <b-col class="text-center"
                  ><img
                    class="logo mb-3"
                    src="/img/brand/RGB Travel Places Primary Logo.bmp"
                    alt="Travel Places"
                    height="70"
                    width="190"
                  /><br />
                  <span>
                    Travel Places, in association with American Express Global
                    Business Travel
                  </span>
                </b-col>
                <b-col cols="2">
                  <img
                    class="logo h-30px mt-4"
                    src="/img/brand/IATA.jpg"
                    alt="IATA"
                  />
                </b-col>
              </b-row>
              <b-row class="text-center strong">
                <b-col
                  >Podium House 61 Chapel Road, Worthing, West Sussex, BN11 1HR
                  T: +44 (0) 1903 832888 F: +44 (0) 1903 231179</b-col
                >
              </b-row>
            </div>
            <div class="border-black border-top-none p-4">
              <div class="text-center large strong underline">
                Car Rental Voucher
              </div>

              Car Rental Company:
              <span v-if="item.supplier" class="strong">{{ item.supplier.name }}</span
              ><br />
              <span v-if="item.blphone">
                Local Phone Number:
                <span class="strong">{{ item.blphone }}</span>
                <br />
              </span>
              <br />
              Travel Places Agent Reference:
              <span v-if="item.agent" class="strong">{{ item.agent }}</span
              ><br />
              <span v-if="item.consultant">
                Email: <span class="strong">{{ item.consultant.email }}</span>
              </span>
              <br />
            </div>
            <div class="border-black border-top-none p-4">
              <span class="strong"> BOOKING DETAILS</span><br />
              Reservation number:
              <span class="strong">{{ item.confirmationno }} </span><br />
              Driver Name (s): <span class="strong">{{ item.driver }}</span
              ><br />
              <span v-if="item.cargroup"
                >Car Group:
                <span class="strong">{{ item.car }} {{ item.cargroup }}</span
                ><br
              /></span>
              <br />

              <span class="strong"> Pick Up: </span>
              <span v-if="item.pickupdate">{{ item.pickupdate }}</span>
              <span v-if="item.pickuptime"> @ {{ item.pickuptime }}</span>
              <span v-if="item.pickupdate || item.pickuptime">,&nbsp;</span>
              <span v-if="item.pickuplocation">{{ item.pickuplocation }}</span>
              <br />
              <span class="strong"> Drop Up: </span>
              <span v-if="item.dropoffdate">{{ item.dropoffdate }}</span>
              <span v-if="item.dropofftime"> @ {{ item.dropofftime }}</span>
              <span v-if="item.dropoffdate || item.dropofftime">,&nbsp;</span>
              <span v-if="item.dropofflocation">{{
                item.dropofflocation
              }}</span>
              <br />

              <div v-if="item.notes">
                <br />
                <span class="strong">BOOKING NOTES </span>
                <br />
                {{ item.notes }}
              </div>
            </div>
            <div class="border-black border-top-none p-4">
              <span class="strong">Company to be invoiced:</span> <br />
              Account: <span class="strong">{{ item.client.slac }}</span> <br />
              Company: <span class="strong">{{ item.client.name }}</span
              ><br />
              Account: <span class="strong">Paid By Travel Places</span><br />
              <!-- [ X ] Invoiced To Account [
            &nbsp;&nbsp;&nbsp; ] Direct By Client [ &nbsp;&nbsp;&nbsp; ]<br /> -->
              <!-- (paymethod: {{slac_item.paymethod}}, invoicetype: {{slac_item.invoicetype}},       accounttype: {{slac_item.accounttype}}, statementtype: {{slac_item.statementtype}}) -->
            </div>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "CarVoucher",
  data() {
    return {
      loading: false,
      documentformat: "CAR_1",
      item: {
        items: [],
        client: {
          slac: "",
          name: ""
        }
      },
      id: null,
    };
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings($id: String) {
              carbookings(id: $id) {
                id
                driver
                slac
                blac
                blphone
                car
                cargroup
                confirmationno
                pickupdate
                pickuptime
                pickuplocation
                dropoffdate
                dropofftime
                dropofflocation
                message
                agent
                notes
                supplier {
                  name
                }
                client {
                  name
                  slac
                }
                consultant {
                  initials
                  email
                }
              }
            }
          `,
          variables,
        });

        this.item = response.data.carbookings[0];

        this.item.pickupdate = this.$helpers.datefield(this.item.pickupdate);
        this.item.dropoffdate = this.$helpers.datefield(this.item.dropoffdate);
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;
      let variables = {
        id: this.idselected,
        documentformat: this.documentformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings($id: String, $documentformat: String) {
              carbookings(id: $id, documentformat: $documentformat) {
                id
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.carbookings.length > 0) {
          let byteCharacters = atob(response.data.carbookings[0].documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, "car_" + response.data.carbookings[0].id + ".pdf");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style>
</style>
